module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "toDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }) : _c('input-mask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Search",
      "icon": "pi pi-search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchPosSalesReport.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5"
  }, [(this.salesChildDeletedHeaderLists.length > 0) ? _c('Button', {
    staticClass: "p-button-raised p-button-warning",
    attrs: {
      "icon": "pi pi-refresh",
      "label": "Reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.cashSales))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('label', {
    ref: "name",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(this.esewaSales))])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [(this.salesChildDeletedHeaderLists.length > 0) ? _c('a', {
    staticClass: "p-field p-col-12 p-md-12",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCSV()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "float": "right",
      "height": "3em",
      "width": "3em"
    },
    attrs: {
      "src": require("../../../../static/img/excel.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.salesChildDeletedHeaderLists,
      "paginator": true,
      "editMode": "cell",
      "rows": 100,
      "filters": _vm.filters,
      "rowsPerPageOptions": [100, 500, 1000],
      "data-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "Date",
      "sortable": true,
      "field": "salesDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesDate', $$v)
            },
            expression: "filters['salesDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Miti",
      "sortable": true,
      "field": "salesDateNepali",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesDateNepali']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesDateNepali', $$v)
            },
            expression: "filters['salesDateNepali']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Time",
      "sortable": true,
      "field": "time",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['time']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'time', $$v)
            },
            expression: "filters['time']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bill No",
      "sortable": true,
      "field": "billPrefix",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billPrefix']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billPrefix', $$v)
            },
            expression: "filters['billPrefix']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Customer",
      "sortable": true,
      "field": "customerName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['customerName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'customerName', $$v)
            },
            expression: "filters['customerName']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                Total:\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Contact",
      "sortable": true,
      "field": "contactNumber",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['contactNumber']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'contactNumber', $$v)
            },
            expression: "filters['contactNumber']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Address",
      "sortable": true,
      "field": "deliveryAddress",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['deliveryAddress']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'deliveryAddress', $$v)
            },
            expression: "filters['deliveryAddress']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Pay Status",
      "bodyStyle": "text-align: right",
      "field": "paymentStatus",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['paymentStatus']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'paymentStatus', $$v)
            },
            expression: "filters['paymentStatus']"
          }
        })]
      },
      proxy: true
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(_vm.getPayStatusLabel(slotProps.data.paymentStatus)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Pay Method",
      "sortable": true,
      "field": "paymentMethod",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['paymentMethod']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'paymentMethod', $$v)
            },
            expression: "filters['paymentMethod']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Dis Amt",
      "bodyStyle": "text-align: right",
      "field": "discountAmount",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['discountAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'discountAmount', $$v)
            },
            expression: "filters['discountAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalDiscountAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Amount",
      "bodyStyle": "text-align: right",
      "field": "billAmount",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billAmount', $$v)
            },
            expression: "filters['billAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalBillAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Counter",
      "bodyStyle": "text-align: right",
      "field": "counterName",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['counterName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'counterName', $$v)
            },
            expression: "filters['counterName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Store",
      "bodyStyle": "text-align: right",
      "field": "warehouseName",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['warehouseName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'warehouseName', $$v)
            },
            expression: "filters['warehouseName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Entered By",
      "bodyStyle": "text-align: right",
      "field": "enteredBy",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['enteredBy']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'enteredBy', $$v)
            },
            expression: "filters['enteredBy']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Updated By",
      "bodyStyle": "text-align: right",
      "field": "updatedBy",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['updatedBy']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'updatedBy', $$v)
            },
            expression: "filters['updatedBy']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Reason",
      "bodyStyle": "text-align: right",
      "field": "deleteReason",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['deleteReason']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'deleteReason', $$v)
            },
            expression: "filters['deleteReason']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action",
      "headerStyle": "width:14em"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('View Details'),
            expression: "'View Details'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-warning",
          attrs: {
            "icon": "pi pi-eye"
          },
          on: {
            "click": function($event) {
              return _vm.viewPOSSalesDetail(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Print'),
            expression: "'Print'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-secondary",
          attrs: {
            "icon": "pi pi-print"
          },
          on: {
            "click": function($event) {
              return _vm.printPage(slotProps.data)
            }
          }
        }), _vm._v(" "), (slotProps.data.deliveryAddress !== '') ? _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Exchange'),
            expression: "'Exchange'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-secondary",
          attrs: {
            "icon": "pi pi-refresh"
          },
          on: {
            "click": function($event) {
              return _vm.printExchangePage(slotProps.data)
            }
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticClass: "pink--text"
  }, [_c('th', {
    staticClass: "title"
  }, [_vm._v("Totals")])])])], 2)], 1)])])]), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteReport
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Total Cash Sales R.s: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "margin-left": "12%"
    },
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Total Esewa Sales R.s: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e074f87c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/posSalesDeleteReport.vue
// module id = 2420
// module chunks = 0